import { Info } from "lucide-react";

/**
 * #19934 — nói rõ lịch đang đặt sẽ đi đâu và bệnh nhân cầm số NÀO.
 *
 * Có phòng → đặt vào phòng: STT vào phòng, đến thẳng phòng. Không phòng → đặt vào QUẦY TIẾP ĐÓN:
 * STT quầy, lễ tân chỉ định phòng. Hai số khác nhau, và người đặt lịch phải biết mình đang cấp số
 * nào trước khi bấm Lưu.
 */
export function BookingDestinationNote({
  roomId,
  departmentId,
}: {
  roomId: string;
  departmentId: string;
}) {
  return (
    <p
      data-testid="booking-destination"
      className="flex items-start gap-2 rounded-md border px-3 py-2 text-sm"
    >
      <Info className="mt-0.5 size-4 shrink-0 text-muted-foreground" />
      {roomId ? (
        <span>
          <strong>Đặt vào phòng</strong> — bệnh nhân nhận <strong>STT vào phòng</strong> ngay khi
          đặt và đến thẳng phòng khám, không qua quầy tiếp đón.
        </span>
      ) : (
        <span>
          <strong>Đặt vào quầy tiếp đón</strong> — chưa chọn phòng, nên bệnh nhân nhận{" "}
          <strong>STT quầy tiếp đón</strong> và đến quầy để lễ tân chỉ định phòng
          {departmentId ? " trong khoa đã chọn" : ""}.
        </span>
      )}
    </p>
  );
}
